import { useParams } from 'react-router-dom';
import { UserQuery } from 'queries';

function useDetail() {
  const { id } = useParams<{ id: string }>();
  const { data: user } = UserQuery.useGet(id || '');

  return { user };
}

export default useDetail;
